<div class="page-container">
  <!--<app-gradient-box>-->
    <div class="content-container">
      <ng-content></ng-content>
    </div>
  <!--</app-gradient-box>-->
</div>
